<svg width="3" height="16" viewBox="0 0 3 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="icn_menu copy">
<circle id="Oval" cx="1.5" cy="1.5" r="1.5" fill="#080828"/>
<circle id="Oval_2" cx="1.5" cy="8" r="1.5" fill="#080828"/>
<circle id="Oval_3" cx="1.5" cy="14.5" r="1.5" fill="#080828"/>
</g>
</svg>
